module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-words"
  }, [_c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-articles"
  }, [_c('div', {
    staticClass: "inside"
  }, [(_vm.pageWord.header_text) ? _c('div', {
    staticClass: "text-center headline-container"
  }, [_c('h1', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.pageWord.header_text.value))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "toggle-filter",
    class: {
      isOpen: _vm.showSelect
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.dropSelect()
      }
    }
  }, [_vm._v("FILTER")]), _vm._v(" "), ((_vm.showSelect) || (!this.$breakpoints.isMobile())) ? _c('div', {
    staticClass: "filter-container container-fluid "
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "select-container",
    class: {
      isOpen: _vm.visibleCategories
    }
  }, [_c('dropdown', {
    attrs: {
      "visible": _vm.visibleCategories,
      "position": _vm.position,
      "animation": 'ani-fade'
    },
    on: {
      "clickOut": function($event) {
        _vm.visibleCategories = false
      }
    }
  }, [_c('span', {
    staticClass: "select",
    on: {
      "click": function($event) {
        _vm.visibleCategories = !_vm.visibleCategories
      }
    }
  }, [_vm._v(_vm._s(_vm.selectedCategoryTitle))]), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('li', {
    attrs: {
      "value": "",
      "title": 'All Categories'
    },
    on: {
      "click": function($event) {
        return _vm.filterBy($event)
      }
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.taxonomyCategories), function(option) {
    return _c('li', {
      attrs: {
        "title": option.name,
        "value": '&elements.word_category[all]=' + option.codename
      },
      on: {
        "click": function($event) {
          return _vm.filterBy($event)
        }
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "search-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "name": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "id": "searchIcon",
      "src": _vm.searchIcon,
      "alt": "Search Icon"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('articles-wrapper', {
    attrs: {
      "boxes": _vm.filteredArticles,
      "search": _vm.search,
      "isHome": false,
      "boxlimit": 3,
      "pathRoute": '/words',
      "showCategory": true
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-419ac486","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Words.vue
// module id = 1516
// module chunks = 0